import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Logo } from './common/Logo';
interface AssistantSelectorProps {
  currentAssistant: string;
  onAssistantChange: (assistant: string) => void;
}
const assistants = ['Violent Crimes', 'Property Crimes', 'Fraud & Financial Crimes', 'Drug Offenses', 'Public Order Offenses', 'Other Offenses'];
export const AssistantSelector = ({
  currentAssistant,
  onAssistantChange
}: AssistantSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedAssistant, setSelectedAssistant] = useState(currentAssistant);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleAssistantSelect = (assistant: string) => {
    onAssistantChange(assistant);
    setSelectedAssistant(assistant);
    setIsOpen(false);
    if (assistant === 'Evidence') {
      navigate('/evidence');
    } else {
      navigate('/');
    }
  };
  return <div className="relative" ref={dropdownRef} data-id="element-40">
      <button onClick={() => setIsOpen(!isOpen)} className="p-4 w-full flex items-center gap-2 hover:bg-[#2a2a2a] transition-colors" aria-expanded={isOpen} aria-haspopup="true" data-id="element-41">
              <Logo className="text-[#4a90e2]" size={32} data-id="element-42" />
        <span className="text-base font-semibold flex-grow text-left" data-id="element-43">
          {selectedAssistant}
        </span>
        <ChevronDownIcon size={16} className={`text-[#888888] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-44" />
      </button>
      {isOpen && <div className="absolute top-full left-0 w-full bg-[#1a1a1a] border border-[#444444] rounded-b-lg shadow-lg z-50" data-id="element-45">
          <button className="w-full px-4 py-2 text-left text-sm hover:bg-[#2a2a2a] transition-colors" onClick={() => handleAssistantSelect('Blue Partner')} data-id="element-46">
            Blue Partner
          </button>
          <button className="w-full px-4 py-2 text-left text-sm hover:bg-[#2a2a2a] transition-colors" onClick={() => handleAssistantSelect('Evidence')} data-id="element-47">
            Evidence
          </button>
          <div className="border-t border-[#444444]" data-id="element-48" />
          {assistants.map(assistant => <button key={assistant} className="w-full px-4 py-2 text-left text-sm hover:bg-[#2a2a2a] transition-colors" onClick={() => handleAssistantSelect(assistant)} data-id="element-49">
              {assistant}
            </button>)}
        </div>}
    </div>;
};